import { useEffect } from "react";
import getApiUrl from "@/utils/api";

const API = getApiUrl();

export default function usePageTracker(pageName) {
  useEffect(() => {
    fetch(`${API}/track-visit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ page: pageName }),
    }).catch(() => {});
  }, [pageName]);
}
